import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=36966ef3"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/global.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "@/assets/css/main-flex.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports